import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../ui/Toast';
import { useModal } from '../ui/Modal';

export interface SidebarItem {
  label: string;
  path: string;
  viewKey?: string | undefined;
  icon?: React.ReactNode;
  badge?: string | undefined;
  comingSoon?: boolean | undefined;
}

export const SIDEBAR_NAV_ITEMS: SidebarItem[] = [
  {
    label: 'Overview',
    path: '/dashboard',
    viewKey: 'overview',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
  },
  {
    label: 'Applications',
    path: '/dashboard/applications',
    viewKey: 'applications',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
      </svg>
    ),
  },
  {
    label: 'Notice Manager',
    path: '/dashboard/notice-manager',
    viewKey: 'notice-manager',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    label: 'Consent Log',
    path: '/dashboard/consent-log',
    viewKey: 'consent-log',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
  },
  {
    label: 'Certificates',
    path: '/dashboard/certificates',
    viewKey: 'compliance-certificate',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    label: 'Audit Log',
    path: '/dashboard/audit-log',
    viewKey: 'audit-log',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
      </svg>
    ),
  },
  {
    label: 'API Keys',
    path: '/dashboard/api-keys',
    viewKey: 'api-keys',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 0121 9z" />
      </svg>
    ),
  },
  {
    label: 'Settings',
    path: '/dashboard/settings',
    viewKey: 'settings',
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

export interface SidebarProps {
  currentView?: string | undefined;
  onNavigate?: ((view: string) => void) | undefined;
  activeAppId?: string | undefined;
  className?: string | undefined;
}

export function Sidebar({
  currentView,
  onNavigate,
  activeAppId,
  className = '',
}: SidebarProps) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, organisations, activeOrgId, setActiveOrgId, logout } = useAuth();
  const { addToast } = useToast();
  const { openModal } = useModal();

  const [collapsed, setCollapsed] = useState(false);
  const [orgDropdownOpen, setOrgDropdownOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);

  const activeOrg = organisations.find((o) => o.id === activeOrgId);

  const handleItemClick = (item: SidebarItem) => {
    if (item.comingSoon) return;
    if (onNavigate && item.viewKey) {
      onNavigate(item.viewKey);
    } else {
      navigate(item.path);
    }
  };

  const isItemActive = (item: SidebarItem) => {
    if (currentView && item.viewKey) {
      return currentView === item.viewKey;
    }
    return location.pathname === item.path || (item.path !== '/dashboard' && location.pathname.startsWith(item.path));
  };

  const handleLogout = () => {
    setUserDropdownOpen(false);
    openModal({
      title: 'Sign Out?',
      description: 'Are you sure you want to sign out of your account?',
      confirmText: 'Sign Out',
      cancelText: 'Cancel',
      variant: 'destructive',
      onConfirm: async () => {
        await logout();
        navigate('/login');
        addToast({ type: 'info', message: 'Signed out successfully' });
      },
    });
  };

  return (
    <aside
      className={`relative flex flex-col justify-between border-r border-line bg-card/60 backdrop-blur-md transition-all duration-300 ${
        collapsed ? 'w-20' : 'w-64'
      } p-4 ${className}`}
      aria-label="Sidebar navigation"
    >
      <div>
        {/* Header / Brand & Collapse Toggle */}
        <div className="flex items-center justify-between pb-4 mb-4 border-b border-line">
          <div className="flex items-center space-x-2.5 overflow-hidden">
            <div className="h-7 w-7 rounded-xl bg-blue-600 shadow-[0_0_12px_rgba(37,99,235,0.5)] flex items-center justify-center font-bold text-white text-sm shrink-0">
              C
            </div>
            {!collapsed && (
              <div className="flex flex-col">
                <span className="text-sm font-extrabold tracking-tight bg-gradient-to-r from-blue-600 to-indigo-600 dark:from-white dark:to-slate-300 bg-clip-text text-transparent truncate">
                  DPDP Consent
                </span>
                <span className="text-[9px] font-semibold tracking-widest text-sub uppercase -mt-0.5">
                  Consentry Engine
                </span>
              </div>
            )}
          </div>

          <button
            type="button"
            onClick={() => setCollapsed(!collapsed)}
            className="rounded-lg p-1.5 text-sub hover:text-ink hover:bg-slate-500/10 transition cursor-pointer"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <svg
              className={`w-4 h-4 transition-transform duration-300 ${
                collapsed ? 'rotate-180' : 'rotate-0'
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
            </svg>
          </button>
        </div>

        {/* Organization Selector */}
        {organisations.length > 0 && (
          <div className="relative mb-5">
            {!collapsed && (
              <p className="text-[10px] uppercase font-bold tracking-wider text-muted mb-1.5 px-1">
                Organisation
              </p>
            )}
            <button
              type="button"
              onClick={() => setOrgDropdownOpen(!orgDropdownOpen)}
              className="w-full flex items-center justify-between rounded-xl border border-line bg-card/80 px-3 py-2 text-xs text-ink hover:border-blue-500/40 transition cursor-pointer"
              title={activeOrg?.name}
            >
              <div className="flex items-center space-x-2 truncate">
                <div className="h-5 w-5 rounded-lg bg-blue-500/20 text-blue-500 font-bold flex items-center justify-center text-[10px] shrink-0">
                  {activeOrg?.name?.[0]?.toUpperCase() || 'O'}
                </div>
                {!collapsed && (
                  <span className="font-semibold truncate">{activeOrg?.name || 'Select Org'}</span>
                )}
              </div>
              {!collapsed && <span className="text-sub text-[10px]">▼</span>}
            </button>

            {/* Org Dropdown menu */}
            {orgDropdownOpen && (
              <div className="absolute left-0 right-0 z-50 mt-1 rounded-xl border border-line bg-card shadow-cardhover p-1 space-y-1">
                {organisations.map((org) => (
                  <button
                    key={org.id}
                    type="button"
                    onClick={() => {
                      setActiveOrgId(org.id);
                      setOrgDropdownOpen(false);
                      addToast({ type: 'success', message: `Switched to ${org.name}` });
                    }}
                    className={`w-full flex items-center justify-between rounded-lg px-2.5 py-1.5 text-xs text-left cursor-pointer transition ${
                      org.id === activeOrgId
                        ? 'bg-blue-500/10 text-blue-500 font-semibold'
                        : 'text-sub hover:bg-slate-500/10 hover:text-ink'
                    }`}
                  >
                    <span className="truncate">{org.name}</span>
                    <span className="text-[9px] uppercase tracking-wider text-muted ml-1">
                      {org.plan_tier || 'free'}
                    </span>
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* Navigation Items */}
        <nav className="space-y-1" aria-label="Main Navigation">
          {SIDEBAR_NAV_ITEMS.map((item) => {
            const active = isItemActive(item);
            return (
              <button
                key={item.label}
                type="button"
                onClick={() => handleItemClick(item)}
                className={`w-full flex items-center ${
                  collapsed ? 'justify-center px-2 py-2.5' : 'justify-between px-3 py-2.5'
                } rounded-xl text-xs font-medium transition cursor-pointer ${
                  active
                    ? 'bg-blue-500/10 text-blue-500 font-semibold border border-blue-500/20 shadow-sm'
                    : 'text-sub hover:bg-slate-500/10 hover:text-ink'
                }`}
                title={collapsed ? item.label : undefined}
                aria-current={active ? 'page' : undefined}
              >
                <div className="flex items-center space-x-3 truncate">
                  <span className={`${active ? 'text-blue-500' : 'text-sub'}`}>{item.icon}</span>
                  {!collapsed && <span className="truncate">{item.label}</span>}
                </div>
                {!collapsed && item.badge && (
                  <span className="rounded-full bg-blue-500/20 text-blue-400 px-1.5 py-0.5 text-[9px] font-bold">
                    {item.badge}
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>

      {/* Footer / User status & App ID */}
      <div className="pt-4 border-t border-line space-y-3">
        {activeAppId && !collapsed && (
          <div className="rounded-xl border border-line bg-card/40 p-2 text-[10.5px]">
            <span className="text-muted block font-semibold uppercase text-[9px] tracking-wider mb-0.5">
              Active App
            </span>
            <span className="mono text-sub truncate block" title={activeAppId}>
              {activeAppId}
            </span>
          </div>
        )}

        {user && (
          <div className="relative">
            <button
              type="button"
              onClick={() => setUserDropdownOpen(!userDropdownOpen)}
              className={`w-full flex items-center ${
                collapsed ? 'justify-center p-1.5' : 'justify-between p-2'
              } rounded-xl border border-line bg-card hover:bg-slate-500/10 transition cursor-pointer`}
              title={user.email}
            >
              <div className="flex items-center space-x-2.5 truncate">
                <div className="h-7 w-7 rounded-full bg-gradient-to-tr from-blue-600 to-indigo-600 text-white font-bold text-xs flex items-center justify-center shrink-0">
                  {(user.fullName || user.email)[0]?.toUpperCase()}
                </div>
                {!collapsed && (
                  <div className="flex flex-col text-left truncate">
                    <span className="text-xs font-semibold text-ink truncate">
                      {user.fullName || 'User'}
                    </span>
                    <span className="text-[10px] text-muted truncate">{user.email}</span>
                  </div>
                )}
              </div>
            </button>

            {userDropdownOpen && (
              <div className="absolute bottom-full left-0 right-0 z-50 mb-2 rounded-xl border border-line bg-card shadow-cardhover p-2 space-y-1">
                <button
                  type="button"
                  onClick={() => {
                    setUserDropdownOpen(false);
                    navigate('/dashboard/settings');
                  }}
                  className="w-full text-left px-3 py-2 text-xs text-sub hover:bg-slate-500/10 hover:text-ink rounded-lg transition"
                >
                  Account Settings
                </button>
                <button
                  type="button"
                  onClick={handleLogout}
                  className="w-full text-left px-3 py-2 text-xs text-err hover:bg-red-500/10 rounded-lg transition font-medium"
                >
                  Sign Out
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </aside>
  );
}
